import getPath from './getPath';

// ----------------------------------------------------------------------------

function getExtension(filename: string): string {
    return getPath(filename).extension;
}

// ----------------------------------------------------------------------------

export default getExtension;
